<template>
  <b-modal
    id="gift-card-transfer-modal"
    @hidden="onHidden"
    no-close-on-backdrop
    no-close-on-esc
  >
    <template v-slot:modal-title>
      <b-row>
        <b-col>
          {{ trans('transfer_gift_card') }}
          <small v-if="!!gift_card" class="text-muted ml-2">
            #{{ gift_card.no_display }}
          </small>
        </b-col>
      </b-row>
    </template>
    <div class="p-3 p-md-0">
      <p>{{ trans('gift_card_transfer_about') }}</p>
      <b-row>
        <b-col class="col-12 col-md-6">
          <b-form-group :label="trans('first_name') + '*'">
            <b-form-input
              size='md'
              name='first_name'
              v-model="first_name"
              :state="isFirstNameValid"
              required
              :disabled="busy"
              @focus="$emit('clear-error','first_name')"
            />
            <b-form-invalid-feedback :state="errors && errors.first_name ? false : null">
              {{ errors ? (errors.first_name||[]).join(' ') : '' }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col class="col-12 col-md-6">
          <b-form-group :label="trans('last_name') + '*'">
            <b-form-input
              size='md'
              name='last_name'
              v-model="last_name"
              :state="isLastNameValid"
              required
              :disabled="busy"
              @focus="$emit('clear-error','last_name')"
            />
            <b-form-invalid-feedback :state="errors && errors.last_name ? false : null">
              {{ errors ? (errors.last_name||[]).join(' ') : '' }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-form-group :label="trans('email') + '*'">
        <b-form-input
          size='md'
          name='email'
          v-model="email"
          :state="isEmailValid"
          required
          :disabled="busy"
          @focus="$emit('clear-error','email')"
        />
        <b-form-invalid-feedback :state="errors && errors.email ? false : null">
          {{ errors ? (errors.email||[]).join(' ') : '' }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group :label="trans('custom_message')">
        <b-form-textarea
          size='md'
          name='message'
          v-model="message"
          :state="isMessageValid"
          :disabled="busy"
          @focus="$emit('clear-error','message')"
        />
        <b-form-invalid-feedback :state="errors && errors.message ? false : null">
          {{ errors ? (errors.message||[]).join(' ') : '' }}
        </b-form-invalid-feedback>
      </b-form-group>

      <p v-if="busy">
        <i class="fa fa-fw fa-circle-notch fa-spin"></i>
        {{ trans('please_wait') }}
      </p>
      <p v-if="error" class="text-danger">
        {{ error }}
      </p>
    </div>
    <template #modal-footer>
      <b-row>
        <b-col>
          <b-button variant="light" @click="$bvModal.hide('gift-card-transfer-modal')">
            {{ trans('cancel') }}
          </b-button>
          <b-button variant="primary" @click="$bvModal.show('confirm-transfer-modal')" :disabled="busy || !isValid">
            {{ trans('transfer') }}
          </b-button>
        </b-col>
      </b-row>
    </template>
    <confirm-modal
      id='confirm-transfer-modal'
      size="md"
      :title="trans('confirm_transfer')"
      :okTitle="trans('confirm_transfer')"
      :message="trans('confirm_transfer_about')"
      :elements="confirmCard"
      @confirm="onTransfer"
    ></confirm-modal>
      
  </b-modal>
</template>

<script>

  function isEmpty(value) {
    return _.isEmpty(value) || ((value||'')+'').trim().length == 0
  }

  import ConfirmModal from '../../../common/components/ConfirmModal'

  export default {
    props: {
      gift_card: Object,
      organization: Object
    },
    components: {
      ConfirmModal
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        first_name: null,
        last_name: null,
        email: null,
        message: null,
        errors: {}
      }
    },
    computed: {
      isFirstNameValid() {
        if (this.errors?.first_name) return false
        if (this.first_name) return true
        return null
      },
      isLastNameValid() {
        if (this.errors?.last_name) return false
        if (this.last_name) return true
        return null
      },
      isEmailValid() {
        if (this.errors?.email) return false
        if (isEmpty(this.email)) return null
        return _.validateEmail(this.email)
      },
      isMessageValid() {
        if (this.errors?.message) return false
        if (!this.message) return null
      },
      isValid() {
        return this.isFirstNameValid &&
          this.isLastNameValid &&
          this.isEmailValid
      },
      serialized() {
        return {
          first_name: this.first_name,
          last_name: this.last_name,
          email: this.email,
          message: this.message || null,
          card_no: this.gift_card.gift_card_no,
        }
      },
      confirmCard() {
        return [
          `${trans('first_name')}: ${this.first_name}`,
          `${trans('last_name')}: ${this.last_name}`,
          `${trans('email')}: ${this.email}`,
        ]
      }
    },
    methods: {
      onHidden() {
        this.busy = false
        this.error = null
        this.errors = {}
        this.first_name = null
        this.last_name = null
        this.email = null
        this.message = null
      },
      onTransfer() {
        this.busy = true
        this.error = null
        let url = `/org/${this.organization.id}/client/gift_card/${this.gift_card.gift_card_no}/transfer`
        const method = 'post'
        axios[method](url, this.serialized)
        .then(response => {
          this.$emit('transfered')
          this.busy = false
          let success_message = this.getSuccessMessage(response.data)
          this.$bvModal.hide('gift-card-transfer-modal')
          _.toastSuccess(this, success_message)
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      getSuccessMessage(data) {
        let name = data.recipient_name
        let email = data.recipient_email
        let card_no = data.card_no
        return this.trans('transfer_success', { gift_card_no: card_no, name: name, email: email})
      }
    },
    mounted() {
      window.giftCardTransferModal = this
    },
  }
</script>